module.exports = __webpack_public_path__ + "img/pp-45.acfe64b0.jpg";